import csv from './downloaders/csv.js';
import json from './downloaders/json.js';
import pdf from './downloaders/pdf.js';
import xlsx from './downloaders/xlsx.js';
import html from './downloaders/html.js';

export default {
	csv:csv,
	json:json,
	pdf:pdf,
	xlsx:xlsx,
	html:html,
};